import { apiOld } from './api';
import tokenService from '../../auth/TokenService';

interface IntercomTokenResponse {
  data: {
    token: string
  }
}

export const getIntercomToken = async () => {
  return await apiOld.post<IntercomTokenResponse>(
    'user-management/intercom/tokens',
    undefined,
    {
      headers: {
        Authorization: `Bearer ${tokenService.getCookieAccessToken()}`
      }
    }
  ).then((result) => result.data.data.token);
};
